import { Text } from "@/components/Primitives/Text"
import { AuthLogo } from "@/components/Primitives"

interface AuthLayoutProps {
  description: string
  imageUrl: string
  children: React.ReactNode
}

export function AuthLayout({
  description,
  imageUrl,
  children,
}: AuthLayoutProps) {
  return (
    <div className="flex flex-col min-h-[calc(100dvh-2rem)] w-full">
      <AuthLogo />

      <section className="w-full flex flex-col overflow-hidden md:flex-row md:items-center md:justify-center md:self-center flex-1">
        <div className="w-full md:w-6/12 flex flex-col flex-1 m-0 p-0 md:h-[70dvh]">
          <div className="hidden md:flex flex-1 relative overflow-hidden">
            <img
              src={imageUrl}
              className="hidden md:flex absolute inset-0 w-full h-full object-scale-down object-center"
            />
          </div>
          <Text className="w-full max-w-sm text-center text-purple-100 text-md leading-relaxed mx-auto py-5 flex-shrink-0 md:py-3 md:pt-9">
            {description}
          </Text>
        </div>
        <div className="w-full h-full flex flex-col justify-center md:w-6/12 md:h-[70dvh]">
          {children}
        </div>
      </section>
    </div>
  )
}
